module.exports = __webpack_public_path__ + "static/media/lab_desktablet_overlay.43a5f4e5.svg";